<div class="dl-dialog">
  <div class="dl-header">
    <div class="dl-title-wrap">
      <div class="dl-title-icon"><mat-icon>content_copy</mat-icon></div>
      <div>
        <h2 class="dl-title">Copy data library items</h2>
        <div class="dl-subtitle">Copy fields from this library to your other companies</div>
      </div>
    </div>
    <button mat-icon-button mat-dialog-close class="dl-close" [disabled]="saveClicked" aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <form id="dataLibraryMigrate" class="dl-body" (ngSubmit)="moveClick()">
    <div class="dl-field">
      <div class="dl-label-row">
        <label class="dl-label">Data library items <span class="dl-req">*</span></label>
        <span class="dl-count" [class.on]="selectedItemCount > 0">{{selectedItemCount}} selected</span>
      </div>
      <mat-form-field appearance="outline" class="dl-mat full-width">
        <mat-select [formControl]="selectedDataCollectionDefinitions" multiple placeholder="Select data library items">
          <mat-option>
            <ngx-mat-select-search
              [formControl]="dataFilterCtrl"
              placeholderLabel="Find data fields..."
              noEntriesFoundLabel="No matching data field">
            </ngx-mat-select-search>
          </mat-option>
          <mat-option disabled="disabled" class="filter-option">
            <button mat-raised-button class="mat-primary fill text-sm" type="button" (click)="selectAll()">Select All</button>
            <button mat-raised-button class="mat-accent fill text-sm" type="button" style="margin-left: 10px;" (click)="change([])">Deselect All</button>
          </mat-option>
          <mat-select-trigger>
            @if (selectedDataCollectionDefinitions.value?.[0] == null) {
              None selected
            } @else {
              {{selectedDataCollectionDefinitions.value?.[0].name || ''}}
              @if (selectedItemCount > 1) {
                <span class="example-additional-selection">(+{{selectedItemCount - 1}} {{selectedItemCount === 2 ? 'other' : 'others'}})</span>
              }
            }
          </mat-select-trigger>
          @for (item of filteredDataCollectionDefinitions | async; track item.id) {
            <mat-option [value]="item">{{item.name}}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>

    <div class="dl-field dl-field-last">
      <div class="dl-label-row">
        <label class="dl-label">Copy to companies <span class="dl-req">*</span></label>
        <span class="dl-count" [class.on]="otherCompanies.length > 0">{{otherCompanies.length}} selected</span>
      </div>
      <app-company-select-multiple
        class="dl-picker"
        [companyIdsToExclude]="companyIdsToExclude"
        [(selectedCompanies)]="otherCompanies">
      </app-company-select-multiple>
    </div>
  </form>

  <div class="dl-footer">
    <span class="dl-footer-note">
      <mat-icon>info_outline</mat-icon>
      Items are copied—the originals stay in this library.
    </span>
    <div class="dl-footer-actions">
      <button mat-button mat-dialog-close class="dl-btn-ghost" [disabled]="saveClicked">Cancel</button>
      <button
        id="data_library_migrate_save"
        type="submit"
        form="dataLibraryMigrate"
        class="dl-btn-primary"
        [disabled]="saveClicked || selectedItemCount === 0 || otherCompanies.length === 0">
        @if (saveClicked) {
          <mat-spinner diameter="20" strokeWidth="3"></mat-spinner>
        } @else {
          <span>Copy items</span><mat-icon>check</mat-icon>
        }
      </button>
    </div>
  </div>
</div>
